document.addEventListener('DOMContentLoaded', function () {

    if (document.querySelector('.anaphylaxis-hero-slider')) {
        const swiper = new Swiper('.anaphylaxis-hero-slider', {
            direction: "horizontal",
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            observer: true,
            observeParents: true,
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
            },
        });
    }

    if (document.querySelector('.anaphylaxis-treatment-slider')) {
        const swiper = new Swiper('.anaphylaxis-treatment-slider', {
            direction: "horizontal",
            slidesPerView: 1,
            spaceBetween: 10,
            loop: false,
            observer: true,
            observeParents: true,
            pagination: {
                el: '.anaphylaxis-treatment-slider .swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.anaphylaxis-treatment-slider .swiper-button-next',
                prevEl: '.anaphylaxis-treatment-slider .swiper-button-prev',
            },

            on: {
                slideChangeTransitionEnd: function () {
                    dataLayer.push({
                        event: 'web_dad_slider',
                        slidernumber: '1',
                        slide: this.slides[this.activeIndex].dataset.slide,
                        property:'adult'
                    });
                }
            }
        });
    }

    document.querySelector('.anaphylaxis-treatment .custom-swiper-button-next')?.addEventListener('click', function () {
        document.querySelector('.anaphylaxis-treatment-slider .swiper-button-next')?.click();
    });

    document.querySelector('.anaphylaxis-treatment .custom-swiper-button-prev')?.addEventListener('click', function () {
        document.querySelector('.anaphylaxis-treatment-slider .swiper-button-prev')?.click();
    });

    if (document.querySelector('.anaphylaxis-safety-slider')) {
        const swiper = new Swiper('.anaphylaxis-safety-slider', {
            direction: "horizontal",
            slidesPerView: "auto",
            spaceBetween: 24,
            loop: true,
            observer: true,
            observeParents: true,
            centeredSlides: true,
            pagination: {
                el: '.anaphylaxis-safety-slider .swiper-pagination',
                clickable: true,
            },
        });
    }

    if (document.querySelector('.anaphylaxis-act-fast-slider')) {
        const swiper = new Swiper('.anaphylaxis-act-fast-slider', {
            direction: "horizontal",
            slidesPerView: "auto",
            spaceBetween: 24,
            loop: false,
            observer: true,
            observeParents: true,
            autoHeight: true,
            pagination: {
                el: '.anaphylaxis-act-fast-slider .swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.anaphylaxis-act-fast-slider .swiper-button-next',
                prevEl: '.anaphylaxis-act-fast-slider .swiper-button-prev',
            },

            on: {
                slideChangeTransitionEnd: function () {
                    dataLayer.push({
                        event: 'web_dad_slider',
                        slidernumber: '2',
                        slide: this.slides[this.activeIndex].dataset.slide,
                        property:'adult'
                    });
                }
            }
        });
    }

    document.querySelector('.anaphylaxis-act-fast-section .custom-swiper-button-next')?.addEventListener('click', function () {
        document.querySelector('.anaphylaxis-act-fast-slider .swiper-button-next')?.click();
    });

    document.querySelector('.anaphylaxis-act-fast-section  .custom-swiper-button-prev')?.addEventListener('click', function () {
        document.querySelector('.anaphylaxis-act-fast-slider .swiper-button-prev')?.click();
    });

    if (window.innerWidth < 768) {
        if (document.querySelector('.anaphylaxis-video-slider')) {
            const swiper = new Swiper('.anaphylaxis-video-slider', {
                direction: "horizontal",
                slidesPerView: "auto",
                spaceBetween: 20,
                loop: false,
                observer: true,
                observeParents: true,
                centeredSlides: true,
                pagination: {
                    el: '.anaphylaxis-video-slider .swiper-pagination',
                    clickable: true,
                },
            });
        }
    }

    if (document.querySelector('.anaphylaxis-video-model-slider')) {
        const swiper = new Swiper('.anaphylaxis-video-model-slider', {
            direction: "horizontal",
            slidesPerView: 1,
            spaceBetween: 10,
            loop: true,
            observer: true,
            observeParents: true,
            navigation: {
                nextEl: '.anaphylaxis-video-model-slider .swiper-button-next',
                prevEl: '.anaphylaxis-video-model-slider .swiper-button-prev',
            },
        });
    }

    document.querySelector('.custom-video-swiper-button-next')?.addEventListener('click', function () {
        document.querySelector('.anaphylaxis-video-model-slider .swiper-button-next')?.click();
    });

    document.querySelector('.custom-video-swiper-button-prev')?.addEventListener('click', function () {
        document.querySelector('.anaphylaxis-video-model-slider .swiper-button-prev')?.click();
    });

    class AnaphylaxisVideoModal {
        constructor() {
            this.wrapper = document.querySelector('video-wrapper');
            if (!this.wrapper) return;
            this.modal = this.wrapper.querySelector('.anaphylaxis-video-model-wrapper');
            this.cardWrapper = this.wrapper.querySelector('.anaphylaxis-video-card-wrapper');
            this.sliderElement = this.wrapper.querySelector('.anaphylaxis-video-model-slider');
            this.slider = this.sliderElement.swiper;
            this.init();
        }

        init() {
            this.wrapper.addEventListener('click', (e) => {
                const card = e.target.closest('[data-slide-index]');
                if (card) {
                    this.open(Number(card.dataset.slideIndex));
                }
                if (e.target.closest('.anaphylaxis-video-model-close')) {
                    this.close();
                }
            });
        }

        open(index) {
            this.cardWrapper.classList.add('d-none');
            this.modal.classList.remove('d-none');
            this.slider.update();
            this.slider.slideTo(index);
            this.playVideo(index);
            this.modal.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }

        playVideo(index) {
            this.stopAllVideos();
            const iframe = this.slider.slides[index].querySelector('iframe');
            if (!iframe) return;
            const originalSrc = iframe.dataset.src || iframe.src;
            iframe.dataset.src = originalSrc;
            iframe.src = '';
            setTimeout(() => {
                iframe.src = originalSrc + (originalSrc.includes('?') ? '&autoplay=1' : '?autoplay=1');
            }, 50);

            const activeIndex = this.slider?.activeIndex ?? 0;
            const activeSlide = this.slider?.slides?.[activeIndex];

            const videoNumber = activeSlide?.dataset?.videoNumber || activeIndex;

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'web_dad_video_start',
                videonumber: `${videoNumber + 1}`,
                videoaction: 'start',
                property:'adult'
            });
        }

        stopAllVideos() {
            this.slider.slides.forEach((slide) => {
                const iframe = slide.querySelector('iframe');
                if (!iframe) return;
                const originalSrc = iframe.dataset.src || iframe.src;
                iframe.dataset.src = originalSrc;
                iframe.src = '';
                setTimeout(() => {
                    iframe.src = originalSrc;
                }, 50);
            });
        }

        close() {
            this.modal.classList.add('d-none');
            this.cardWrapper.classList.remove('d-none');
            this.stopAllVideos();

            const activeIndex = this.slider?.activeIndex ?? 0;
            const activeSlide = this.slider?.slides?.[activeIndex];

            const videoNumber = activeSlide?.dataset?.videoNumber || activeIndex;

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'web_dad_video_start',
                videonumber: `${videoNumber + 1}`,
                videoaction: 'stop',
                property:'adult'
            });
        }
    }

    new AnaphylaxisVideoModal();

    (() => {
        'use strict';

        const SEL = {
            section: '.severe-allergic',
            heading: '.severe-allergic__heading',
            sub: '.severe-allergic__sub',
            hintLabel: '.severe-allergic__hint-label',
            hint: '.severe-allergic__hint',
            bigIcon: '.severe-allergic__active-icon',
            bigText: '.severe-allergic__active-text',
            buttons: '.severe-allergic__buttons',
        };

        async function loadData() {

            const merged = symptoms.symptoms.map(p => ({
                ...p,

                label: strings.symptoms[p.id].label,

                description:
                strings.symptoms[p.id].description,

                footnote:
                strings.symptoms[p.id].footnote
            }));

            return {
                section: strings.section,

                defaultActive:
                symptoms.default_active,

                symptoms: merged
            };
        }

        function renderIntro(section) {
            document.querySelector(SEL.heading).innerHTML = section.heading;
            document.querySelector(SEL.sub).innerHTML = section.sub;
            document.querySelector(SEL.hintLabel).textContent = section.hint;
        }

        function renderButtons(symptoms, defaultActiveId) {
            const list = document.querySelector(SEL.buttons);
            list.replaceChildren();

            symptoms.forEach((s,index) => {
                const li = document.createElement('li');
                const btn = document.createElement('button');

                // Desktop positioning
                li.style.setProperty('--btn-x', `${s.button_pos_desktop.x_pct}%`);
                li.style.setProperty('--btn-y', `${s.button_pos_desktop.y_pct}%`);
                li.style.setProperty('--btn-size', `${(s.button_size / 1280) * 100}%`);

                // Mobile positioning
                li.style.setProperty('--btn-x-mobile', `${s.button_pos_mobile.x_pct}%`);
                li.style.setProperty('--btn-y-mobile', `${s.button_pos_mobile.y_pct}%`);
                li.style.setProperty('--btn-size-mobile', `${(s.button_size_mobile / 390) * 100}%`);

                btn.type = 'button';
                btn.className = 'severe-allergic__button';
                btn.dataset.symptom = s.id;
                btn.dataset.position = index + 1;
                btn.setAttribute('role', 'tab');
                btn.setAttribute('aria-controls', 'severe-allergic-active');
                btn.setAttribute('aria-label', `Show ${s.label} symptom`);
                btn.setAttribute('aria-selected', s.id === defaultActiveId ? 'true' : 'false');

                const img = document.createElement('img');
                img.src = s.id === defaultActiveId ? s.icon_active : s.icon_default;
                img.alt = '';

                btn.appendChild(img);
                li.appendChild(btn);
                list.appendChild(li);
            });
        }

        function setActive(symptoms, id, opts = {}) {
            const s = symptoms.find(x => x.id === id);
            if (!s) return;

            const root = document.querySelector(SEL.section);

            // Move circle to organ position (desktop + mobile)
            root.style.setProperty('--circle-x', `${s.circle_pos_desktop.x_pct}%`);
            root.style.setProperty('--circle-y', `${s.circle_pos_desktop.y_pct}%`);
            root.style.setProperty('--circle-x-mobile', `${s.circle_pos_mobile.x_pct}%`);
            root.style.setProperty('--circle-y-mobile', `${s.circle_pos_mobile.y_pct}%`);

            // Move pointer dot (desktop + mobile)
            root.style.setProperty('--pointer-x', `${s.pointer_pos_desktop.x_pct}%`);
            root.style.setProperty('--pointer-y', `${s.pointer_pos_desktop.y_pct}%`);
            root.style.setProperty('--pointer-x-mobile', `${s.pointer_pos_mobile.x_pct}%`);
            root.style.setProperty('--pointer-y-mobile', `${s.pointer_pos_mobile.y_pct}%`);

            // Swap big icon + description
            const icon = document.querySelector(SEL.bigIcon);
            const text = document.querySelector(SEL.bigText);
            icon.src = s.icon_big;
            icon.alt = s.label;
            text.innerHTML = `${escapeHtml(s.description)}<sup>${escapeHtml(s.footnote)}</sup>`;

            // Update button states (active → swap icon variant)
            document.querySelectorAll('.severe-allergic__button').forEach(btn => {
                const isActive = btn.dataset.symptom === id;
                btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
                const target = symptoms.find(x => x.id === btn.dataset.symptom);
                if (target) {
                    btn.querySelector('img').src = isActive ? target.icon_active : target.icon_default;
                }
            });

            // Hide "click to view symptom" hint after first interaction
            if (!opts.skipHint) {
                document.querySelector(SEL.hint).classList.add('severe-allergic__hint--hidden');
            }
        }

        function bindInteractions(symptoms) {
            const list = document.querySelector(SEL.buttons);

            list.addEventListener('click', (e) => {
                const btn = e.target.closest('.severe-allergic__button');
                if (!btn) return;
                setActive(symptoms, btn.dataset.symptom);
            });

            // Keyboard arrow nav (a11y)
            list.addEventListener('keydown', (e) => {
                if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) return;
                const buttons = [...list.querySelectorAll('.severe-allergic__button')];
                const idx = buttons.findIndex(b => b.getAttribute('aria-selected') === 'true');
                const next = (['ArrowRight', 'ArrowDown'].includes(e.key))
                    ? (idx + 1) % buttons.length
                    : (idx - 1 + buttons.length) % buttons.length;
                buttons[next].focus();
                setActive(symptoms, buttons[next].dataset.symptom);
            });
        }

        function escapeHtml(str) {
            const map = {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'};
            return String(str).replace(/[&<>"']/g, c => map[c]);
        }

        async function init() {
            try {
                const data = await loadData();
                renderIntro(data.section);
                renderButtons(data.symptoms, data.defaultActive);
                setActive(data.symptoms, data.defaultActive, {skipHint: true});
                bindInteractions(data.symptoms);
            } catch (err) {
                console.error('[anaphylaxis-poc] init failed:', err);
            }
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', init);
        } else {
            init();
        }
    })();

    /* DataLayer Tracking Start*/

    document.querySelectorAll('.dad-cta-btn').forEach((dadCta) => {
        dadCta.addEventListener('click', function () {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'dad_cta_click',
                place: this.dataset.position,
                property:'adult'
            });
        });
    });

    setTimeout(() => {
        document.querySelectorAll('.severe-allergic__button').forEach((dadIcon) => {
            dadIcon.addEventListener('click', function () {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'dad_icon_click',
                    icon_number: this.dataset.position,
                    property:'adult'
                });
            });
        });
    }, 2200);

    /* DataLayer Tracking End */

});